import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import Supermercados from "@/views/Supermercados.vue";
import SupermercadosAtivos from "@/views/SupermercadosAtivos.vue";
import Usuarios from "@/views/Usuarios.vue";
import Categorias from "@/views/Categorias.vue";
import CategoriasApi from "@/views/CategoriasApi.vue";
import Produtos from "@/views/Produtos.vue";
import ProdutosCatalogo from "@/views/ProdutosCatalogo.vue";
import ScanFolheto from "@/views/ScanFolheto.vue";
import NovoScanFolheto from "@/views/NovoScanFolheto.vue";
import FlyerProdutos from "@/views/FlyerProdutos.vue";
import FilaFolhetos from "@/views/FilaFolhetos.vue";
import Welcome from "@/views/Welcome.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/welcome",
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: Welcome,
    meta: { requiresAuth: true }
  },
  {
    path: "/supermercados",
    name: "Supermercados",
    component: Supermercados,
    meta: { requiresAuth: true }
  },
  {
    path: "/supermercados-ativos",
    name: "SupermercadosAtivos",
    component: SupermercadosAtivos,
    meta: { requiresAuth: true }
  },
  {
    path: "/categorias",
    name: "Categorias",
    component: Categorias,
    meta: { requiresAuth: true }
  },
  {
    path: "/categorias-api",
    name: "CategoriasApi",
    component: CategoriasApi,
    meta: { requiresAuth: true }
  },
  {
    path: "/produtos",
    name: "Produtos",
    component: Produtos,
    meta: { requiresAuth: true }
  },
  {
    path: "/produtos-catalogo",
    name: "ProdutosCatalogo",
    component: ProdutosCatalogo,
    meta: { requiresAuth: true }
  },
  {
    path: "/scan-folheto",
    name: "ScanFolheto",
    component: ScanFolheto,
    meta: { requiresAuth: true }
  },
  {
    path: "/novo-scan-folheto",
    name: "NovoScanFolheto",
    component: NovoScanFolheto,
    meta: { requiresAuth: true }
  },
  {
    path: "/folhetos/:id/produtos",
    name: "FlyerProdutos",
    component: FlyerProdutos,
    meta: { requiresAuth: true }
  },
  {
    path: "/fila-folhetos",
    name: "FilaFolhetos",
    component: FilaFolhetos,
    meta: { requiresAuth: true }
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: Usuarios,
    meta: { requiresAuth: true }
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
    meta: { requiresGuest: true }
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
    meta: { requiresGuest: true }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Navigation guard to check authentication
router.beforeEach((to, from, next) => {
  // Temporarily allow all navigation for debugging
  next();
});

// Fecha o menu mobile (drawer) automaticamente após cada navegação
router.afterEach(() => {
  store.commit("closeSidenavMobile");
});

export default router;
